/******************************************************************************************************************************************/
/*  Author: Soft Convergence                                                                                                              */
/*  Date: 29/10/2018                                                                                                                      */
/*  Version: 1.0.2                                                                                                                        */
/*        Remarks:                                                                                                                        */
/*              Include Fix for IE9                                                                                                       */
/*              Include new Look Delphi Technology (blue)                                                                                 */
/******************************************************************************************************************************************/

$(document).ready(function () {

    var cookieName = 'cookie_policy_accepted'

    var declineLabel = { 'EN': 'Decline' };
    var acceptLabel = { 'EN': 'Accept' };
    var closeLabel = { 'EN': 'Close' };

    // check if cookie policy have been accpeted
    if (!readCookie(cookieName)) {
        // Add css compliant with IE8
        var ss1 = document.createElement('style');
        var def = '.cookie-notice {background:#9ca7f0;color:#4d4d4f;padding:15px 0;display:none;font-size:0.9em;font-weight:300;} ' +
            '.cookie-notice a {color:#0000FF; } ' +
            '.cookie-notice a {color:#000;} ' +
            '.cookie-notice a.:hover, .cookie-notice a:focus {text-decoration:underline } ' +
            '.cookie-notice .cookie-actions{margin:16px 0 0;}' +
            '.cookie-notice .cookie-actions button {border:0;background:none;color:#4d4d4f;font-weight:700;font-size:16px;margin: 0 20px 0 0;padding:0;} ' +
            '.cookie-notice .cookie-actions button:hover, .cookie-notice .cookie-actions button:active, .cookie-notice .cookie-actions button:focus {border:0;color:#4d4d4f;background:none;text-decoration:underline;box-shadow:none;outline:none;} ' +
            '.cookie-notice .cookie-actions button:after { content: ""; margin-left: 0px; } ' +
            '.cookie-notice .cookie-close {color:#4d4d4f;display:inline-block;} ' +
            '.cookie-notice .cookie-close:before { content: "x"; display: inline-block; margin-right: 5px; font-weight: 700; } ' +
            '.cookie-notice .cookie-close:hover, .cookie-notice .cookie-close:focus {color:#2d2d2f;text-decoration:underline;}';
        ss1.setAttribute("type", "text/css");
        var hh1 = document.getElementsByTagName('head')[0];
        hh1.appendChild(ss1);
        if (ss1.styleSheet) {   // IE
            ss1.styleSheet.cssText = def;
        } else {                // the world
            var tt1 = document.createTextNode(def);
            ss1.appendChild(tt1);
        }
        // Add html
        var globalDiv = document.createElement('div');
        $(globalDiv).addClass('cookie-notice')
        var container = document.createElement('div');
        $(container).addClass('container')
            .appendTo(globalDiv);

        var colDix = document.createElement('div');
        $(colDix).addClass('col-sm-10')
            .appendTo(container);
        var p1 = document.createElement('p');
        $(p1).text('This website uses cookies to give you the best possible experience. Full details of what cookies are, why we use them and how you manage them can be found in our ')
            .appendTo(colDix);
        var linkPolicy = document.createElement('a');
        $(linkPolicy).attr('href', 'https://www.delphiautoparts.com/en-gb/legal/cookie-policy')
            .attr('target', '_blank')
            .text('Cookie Policy')
            .addClass('cookie-policy-link')
            .appendTo(p1);
        var declineBlock = document.createElement('div');
        $(declineBlock).addClass('decline-message')
            .appendTo(colDix)
            .hide();
        var p2 = document.createElement('p')
        $(p2).text("Certain cookies are necessary in order for you to use our websites. These are used 'in-session' each time you visit and then expire when you leave the site. They’re not stored on your computer and they don't contain any personal data.However, you can delete them via your browser if you wish to, but this will restrict the functions that you're able to carry out on our sites. For a list of essential cookies we use, ")
            .appendTo(declineBlock);
        var clickHere = document.createElement('a');
        $(clickHere).text('Click Here')
            .attr('href', 'https://www.delphiautoparts.com/en-gb/legal/cookie-policy')
            .attr('target', '_blank')
            .appendTo(p2);
        var strongEssential = document.createElement('strong');
        $(strongEssential).text('Essential Cookies: ')
            .prependTo(p2);
        var p3 = document.createElement('p');
        $(p3).text('These cookies are usually supplied by our business partners and help us to filter out irrelevant messages or pop - ups, and to make sure that we only send you information that’s interesting and relevant to you.We also use some non - essential cookies for analytical purposes.')
            .appendTo(declineBlock)
        var strongNonEssential = document.createElement('strong')
        $(strongNonEssential).text('Non-essential Cookies: ')
            .prependTo(p3);
        var p4 = document.createElement('p')
        $(p4).appendTo(declineBlock);
        var strong = document.createElement('strong');
        $(strong).text('You can block any cookies from any website through your browser settings.For more information about how to disable cookies in your browser please visit the ')
            .appendTo(p4);
        var linkAbout = document.createElement('a');
        $(linkAbout).attr('href', 'https://www.aboutcookies.org/')
            .attr('target', '_blank')
            .text('About Cookies Website')
            .appendTo(p4);
        var actions = document.createElement('div');
        $(actions).addClass('cookie-actions')
            .appendTo(colDix);
        var decline = document.createElement('button');
        $(decline).text(declineLabel['EN'])
            .addClass('cookie-decline btn btn-sm')
            .appendTo(actions);
        var accept = document.createElement('button');
        $(accept).text(acceptLabel['EN'])
            .addClass('cookie-accept btn btn-sm btn-delphi')
            .appendTo(actions);
        var colDeux = document.createElement('div');
        $(colDeux).addClass('col-sm-2')
            .appendTo(container);
        var close = document.createElement('a');
        $(close).addClass('cookie-close pull-right')
            .attr('href', '#')
            .text(closeLabel['EN'])
            .appendTo(colDeux);

        $(globalDiv).prependTo('body')
            .show();
    }

    // add event handlers
    $('.cookie-decline').click(function () {
        $('.decline-message').show();
    });

    $('.cookie-accept').click(function () {
        // store in cookie that the user accepted.
        createCookie(cookieName, 'true', 1);
        $('.cookie-notice').remove();
    });

    $('.cookie-close').click(function () {
        $('.cookie-notice').remove();
    });
});

function createCookie(name, value, days) {
    var expires;

    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    } else {
        expires = "";
    }

    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}

function readCookie(name) {
    var nameEQ = encodeURIComponent(name) + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ')
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
            return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }

    return null;
}
